import { ToggleClass } from 'core/toggleClass';

export class ModalVendaRestritaComponent {
    constructor() {
        this.modalSelector = document.querySelectorAll('[data-modal="vendarestrita"]')
        this.modalVendaRestrita = document.querySelector('.modal-vendarestrita')
        this.init()
    }

    init() {
        //Modal Aviseme Toggle Click
        new ToggleClass(this.modalSettings())

    }

    modalSettings() {
        return {
            selector: this.modalSelector,
            target: this.modalVendaRestrita,
            class: 'modal--active',
            callback: this.modalCallback.bind(this),
            blockBodyScroll: true
        }
    }

    modalCallback(event) {
            const item = event.target.getAttribute('data-item');
            const btnAddToCart = this.modalVendaRestrita.querySelector('[data-click="addToCart"]');

            if(item && btnAddToCart) {
                btnAddToCart.setAttribute("data-item", item);
            }
    }
}


// WEBPACK FOOTER //
// ./src/main/webapp/assets/js/components/modal/modal-vendarestrita/modal-vendarestrita.component.js